export function dexpbold(title) {
    if (!String.prototype.replaceAll) {
        String.prototype.replaceAll = function(search, replacement) {
            return this.replace(new RegExp(search, 'g'), replacement);
        };
    }

    // title = title ? title.toUpperCase() : '';
    if (title.indexOf('3DEXP') !== -1) {
        return {
            __html: title.replaceAll('3DEXP', '<span class="bold">3D</span>EXP')
        };
    }
    return {
        __html: title
    };
}

export function getHost() {
    const hostPath = `${window.location.protocol}//${window.location.host}`;
    return hostPath;
}

export function getBaseUrl() {
    const pathArray = window.location.pathname.split('/');
    const contextName = pathArray[1];
    return `${getHost()}/${contextName}`;
}
